import { MarkerWithLabel } from '@googlemaps/markerwithlabel';
import {
    compact,
    flattenDeep,
    forEach,
    head,
    isArray,
    map,
    partialRight,
    pick,
    uniq,
    values,
} from 'lodash-es';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import template from './googleMap.vue';
@Component({
    mixins: [template],
})
export default class GoogleMaps extends Vue {
    @Prop({
        default: {
            lat: 33.922112,
            lng: -118.263168,
        },
    })
    centerLocation: any;

    @Prop({ default: '420px' })
    height: string;

    @Prop({ default: [] })
    locations: Array<any>;

    center: any = {
        lat: 33.922112,
        lng: -118.263168,
    };
    map: google.maps.Map;
    positionsMarkers: Array<any> = [];
    markers: google.maps.Marker[] = [];
    flightPath: google.maps.Polyline;
    flightPaths: google.maps.Polyline[] = [];
    paths: Array<any> = [];
    polylines: Array<any> = [];
    markerArray: google.maps.Marker[] = [];
    directionsService: google.maps.DirectionsService;
    stepDisplay: google.maps.InfoWindow;
    directionsRenderer: google.maps.DirectionsRenderer;
    ctionsRenderers: any;
    origin: any = '';
    destination: any = '';
    isDestination: boolean = false;

    @Watch('locations')
    getmarkers(val: any, oldVal: any) {
        if (val) {
            this.setMaplocations(val);
        } else this.polylines = [];
    }

    created() {}

    mounted() {
        this.initMap();
        this.setMaplocations(this.locations);
    }

    initMap(): void {
        this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
            zoom: 13,
            center: {
                lat: 33.922112,
                lng: -118.263168,
            },
            streetViewControl: false,
            mapTypeControlOptions: {
                mapTypeIds: ['roadmap'],
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            },
            styles: [
                {
                    featureType: 'all',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            weight: 2.0,
                        },
                    ],
                },
                {
                    featureType: 'all',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#9c9c9c',
                        },
                    ],
                },
                {
                    featureType: 'all',
                    elementType: 'labels.text',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#f2f2f2',
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'landscape.man_made',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'all',
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 45,
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#eeeeee',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#7b7b7b',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },

                {
                    featureType: 'water',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#6ab0f6',
                        },
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#e1eaed',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#070707',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },

                {
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'road.local',
                    elementType: 'labels',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
            ],
        });
        this.directionsService = new google.maps.DirectionsService();
        this.stepDisplay = new google.maps.InfoWindow();
        this.panTo(this.center);
    }

    private setMaplocations(val: any) {
        let totalMiles: any = compact(uniq(map(val, 'total_Miles')));
        if (totalMiles.length == 1 && Math.round(totalMiles) > 30) this.isDestination = true;
        else this.isDestination = false;
        if (!this.isNoOriginAndDestination(val)) {
            this.clearMarkers();
            this.clearFlightPath();
            this.map.setCenter({
                lat: 33.922112,
                lng: -118.263168,
            });
            if (this.directionsRenderer && this.directionsRenderer != undefined) {
                this.directionsRenderer.setMap(null);
            }
            return;
        }
        this.positionsMarkers = flattenDeep(val);
        let headMap = head(this.locations);
        this.paths = [];
        if (isArray(headMap)) {
            forEach(this.locations, (location, key) => {
                this.paths.push({
                    ['polylines' + key]: map(location, partialRight(pick, ['lat', 'lng'])),
                });
            });
        } else {
            this.paths.push({
                polylines0: map(val, partialRight(pick, ['lat', 'lng'])),
            });
        }

        this.updateMap(this.center);
    }

    private isNoOriginAndDestination(locations: any) {
        this.origin = '';
        this.destination = '';
        locations.forEach((i: any) => {
            if (
                i['state'] == 'continuous' &&
                i['lat'] &&
                i['lng'] &&
                i['lat'] != 0 &&
                i['lng'] != 0
            )
                this.origin = {
                    lat: i['lat'],
                    lng: i['lng'],
                };
            if (i['state'] == 'finish' && i['lat'] && i['lng'] && i['lat'] != 0 && i['lng'] != 0)
                this.destination = {
                    lat: i['lat'],
                    lng: i['lng'],
                };
        });
        if (!this.origin || !this.destination) {
            this.clearMarkers();
            this.clearFlightPath();
            return false;
        } else {
            this.center = this.origin;
            return true;
        }
    }

    private _directionsService() {
        if (this.directionsRenderer && this.directionsRenderer != undefined) {
            this.directionsRenderer.setMap(null);
        }
        this.directionsRenderer = new google.maps.DirectionsRenderer({
            map: this.map,
            draggable: false,
            hideRouteList: false,
            preserveViewport: false,
            suppressBicyclingLayer: false,
            suppressMarkers: true,
            suppressInfoWindows: false,
            polylineOptions: {
                strokeColor: '#777879',
                strokeWeight: 4,
            },
        });
        this.directionsService.route(
            {
                origin: `${this.origin['lat']},${this.origin['lng']}`,
                destination: `${this.destination['lat']},${this.destination['lng']}`,
                travelMode: google.maps.TravelMode.DRIVING,
                avoidFerries: true,
                avoidTolls: true,
                optimizeWaypoints: false,
                durationInTraffic: true,
                avoidHighways: true,
            },
            (result: any) => {
                this.directionsRenderer.setDirections(result);
                this.clickMarkers({
                    distance: result.routes[0].legs[0].distance.value,
                    finish: result.routes[0].legs[0].end_address,
                    continuous: result.routes[0].legs[0].start_address,
                });
            }
        );
    }

    private showSteps(
        directionResult: google.maps.DirectionsResult,
        markerArray: google.maps.Marker[],
        map: google.maps.Map
    ) {
        const myRoute = directionResult!.routes[0]!.legs[0]!;

        for (let i = 0; i < myRoute.steps.length; i++) {
            const marker = (markerArray[i] = markerArray[i] || new google.maps.Marker());

            marker.setMap(map);
            marker.setPosition(myRoute.steps[i].start_location);
        }
    }

    private attachInstructionText(
        stepDisplay: google.maps.InfoWindow,
        marker: google.maps.Marker,
        text: 'string',
        map: google.maps.Map
    ) {
        google.maps.event.addListener(marker, 'click', () => {
            stepDisplay.setContent(text);
            stepDisplay.open(map, marker);
        });
    }

    private svgMarker(state: string) {
        if (state == 'finish')
            return {
                path:
                    'M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z',
                strokeColor: '#FFFFFF',
                fillColor: '#444545',
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                scale: 1,
                anchor: new google.maps.Point(10, 10),
                labelOrigin: new google.maps.Point(0, 0),
            };

        if (state == 'continuous')
            return {
                path:
                    'M21 12C21 18.1588 16.4427 23 11 23C5.55728 23 1 18.1588 1 12C1 5.84118 5.55728 1 11 1C16.4427 1 21 5.84118 21 12Z',
                strokeColor: '#444545',
                fillColor: '#FFFFFF',
                fillOpacity: 1,
                strokeWeight: 4,
                rotation: 0,
                scale: 0.5,
                anchor: new google.maps.Point(10, 10),
                labelOrigin: new google.maps.Point(0, 0),
            };
    }

    private setMarkers(): void {
        if (this.isDestination)
            this.positionsMarkers.forEach((i: any) => {
                let marker = new MarkerWithLabel({
                    position: new google.maps.LatLng(i['lat'], i['lng']),
                    icon: this.svgMarker(i['state']),
                    title: i['state'],
                    clickable: true,
                    draggable: false,
                    map: this.map,
                    cursor: 'map',
                    optimized: true,
                    zIndex: 1000,
                    labelContent: `<div class="marker-position"><div class="item">${i.city}, ${
                        i.locationState
                    }</div></div>`, // can also be HTMLElement
                    labelAnchor: new google.maps.Point(0, -15),
                    labelClass: 'marker-position',
                });
                this.markers.push(marker);
            });
        else
            this.positionsMarkers.forEach((i: any) => {
                const marker = new google.maps.Marker({
                    position: { lat: i['lat'], lng: i['lng'] },
                    icon: this.svgMarker(i['state']),
                    title: i['state'],
                    map: this.map,
                    cursor: 'map',
                    optimized: true,
                    zIndex: 1000,
                });
                this.markers.push(marker);
            });
    }

    private clickMarkers(result: any) {
        this.markers.forEach(mak => {
            google.maps.event.addListener(mak, 'click', () => {
                let text = 'undefined';
                if (mak['title'] == 'continuous') text = result.continuous;
                if (mak['title'] == 'finish') text = result.finish;
                this.stepDisplay.setContent(text);
                this.stepDisplay.open(this.map, mak);
            });
        });
    }

    private setPolyline(): void {
        forEach(this.paths, (path, key) => {
            const list = new google.maps.Polyline({
                path: flattenDeep(values(path)),
                strokeColor: '#777879',
                strokeOpacity: 0,
                icons: [
                    {
                        icon: {
                            path: 'M 0,-1 0,1',
                            strokeOpacity: 1,
                            scale: 5,
                        },
                        offset: '0',
                        repeat: '20px',
                    },
                ],
                map: this.map,
            });
            this.flightPaths.push(list);
        });
    }

    updateMap(panTo: any) {
        this.clearMarkers();
        this.clearFlightPath();
        this.setMarkers();
        this._directionsService();
        this.panTo(this.center);
    }

    private panTo(panTo: any) {
        this.map.setCenter(panTo);
    }

    private clearFlightPath(): void {
        for (let i = 0; i < this.flightPaths.length; i++) {
            this.flightPaths[i].setMap(null);
        }
        this.flightPaths = [];
    }

    private clearMarkers(): void {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers = [];
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/googleMaps/index.ts